import React from 'react';

const GiftSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1 7c.3-.1.5-.3.7-.4 1-1 1-2.7 0-3.8-.5-.5-1.2-.8-1.9-.8s-1.3.3-1.9.8c-.5.5-.8 1.5-.9 2.5-.2-1-.5-2.1-.9-2.5-.6-.5-1.3-.8-1.9-.8-.7 0-1.4.3-1.9.8-1 1-1 2.7 0 3.8.1.1.4.3.7.4H3v4h2v11h14V11h2V7h-4.9zm-5.4 3L12 8.7l1.3 1.3h-2.6zm3.1-6.5c.3-.3.7-.5 1.1-.5.4 0 .9.2 1.2.5.3.3.5.7.5 1.2 0 .4-.2.9-.5 1.2-.4.4-1.8.7-3.2.9.2-1.5.5-2.9.9-3.3zm-5.7 0c.3-.3.7-.5 1.2-.5.4 0 .9.2 1.2.5.4.4.7 1.8.9 3.2-1.5-.2-3-.5-3.3-.8-.3-.4-.5-.8-.5-1.2 0-.5.2-.9.5-1.2zM4 8h7.3l-2 2H4V8zm2 3h2.3l-1.1 1.1.7.7L9.7 11h1.8v10H6V11zm12 10h-5.5V11h2l1.8 1.8.7-.7-1.1-1.1H18v10zm2-11h-5.2l-2-2H20v2z"
        />
    </svg>
);

GiftSvg.displayName = 'GiftSvg';
export default GiftSvg;
